import { m8API } from 'services/production/m8';
import { normalizeM8AccountInfo } from 'services/production/utils/normalizeM8AccountInfo';
import { TDashboardPageData } from 'types/state';
import { normalizeM8UserFullInfo } from '../utils/normalizeM8UserFullInfo';

export const getDashboardPageData = async (): Promise<TDashboardPageData> => {
  const [userAccountInfo, promoAccountInfos] = await Promise.all([
    m8API.user.getAccountInfo(),
    m8API.admin.getOnlyPromoUsers(),
  ]);

  return {
    accountInfo: normalizeM8AccountInfo(userAccountInfo).toUserAccountInfo(),
    promoAccountsInfo: promoAccountInfos.map((promoAccountInfo) =>
      normalizeM8UserFullInfo(promoAccountInfo).toAccountInfo()
    ),
  };
};
